import {t} from '../../../common/getTranslations';
import {aggregateAndSendLog} from '../../../logging/aggregateAndSendLog';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {ButtonV2Variant} from '../../atoms/ButtonV2/ButtonV2.enum';
import {Dialog} from '../Dialog';

export interface TicketProductChoiceCauseExpiredDialogProps {
  isMobile: boolean;
  productId: number;
  onClickCancel: () => void;
  onClickContinue: () => void;
  onClickNext: () => void;
}

export function TicketProductChoiceCauseExpiredDialog({
  isMobile,
  productId,
  onClickCancel,
  onClickContinue,
  onClickNext,
}: TicketProductChoiceCauseExpiredDialogProps) {
  return (
    <Dialog
      isOpen={true}
      onClose={onClickCancel}
      isUsingScrollBlock={false}
      isMobile={isMobile}
      {...putTiaraObjectProps({
        click: {
          layer1: '이어볼회차선택팝업',
          imp_id: 'popup',
          imp_provider: 'service',
        },
        viewimp_contents: {
          layer1: '이어볼회차선택팝업',
          imp_id: 'popup',
          imp_provider: 'service',
          imp_type: 'vimp',
        },
        customProps: {
          popup_type: '이어볼회차선택팝업',
          event_episode_id: String(productId),
        },
      })}
      onInView={target => {
        aggregateAndSendLog({
          targetElem: target as HTMLElement,
          actionType: 'ViewImp',
          actionName: '팝업_노출',
          customProps: {
            user_action: 'imp',
          },
        });
      }}
    >
      <Dialog.Dimmed />
      <Dialog.Title>{t('contenthome_rental_expired_popup_title')}</Dialog.Title>
      <Dialog.List>
        <Dialog.Label>
          {t('contenthome_rental_expired_popup_message')}
        </Dialog.Label>
      </Dialog.List>
      <Dialog.List>
        <Dialog.Divider />
      </Dialog.List>
      <Dialog.List className="px-18pxr pb-10pxr">
        <Dialog.Button
          onClick={e =>
            LOG_CLICK_EVENT(
              '이어볼회차선택팝업_보던화_클릭',
              e,
              onClickContinue
            )
          }
          variant={ButtonV2Variant.Primary}
        >
          {t('contenthome_rental_expired_popup_viewed_button')}
        </Dialog.Button>
        <Dialog.Button
          onClick={e =>
            LOG_CLICK_EVENT('이어볼회차선택팝업_다음화_클릭', e, onClickNext)
          }
          variant={ButtonV2Variant.Primary}
        >
          {t('contenthome_rental_expired_popup_next_button')}
        </Dialog.Button>
      </Dialog.List>
      <Dialog.BottomCombination>
        <Dialog.Button
          onClick={e =>
            LOG_CLICK_EVENT('이어볼회차선택팝업_취소_클릭', e, onClickCancel)
          }
        >
          {t('common_cancel_button')}
        </Dialog.Button>
      </Dialog.BottomCombination>
    </Dialog>
  );
}
